import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const quizCategories = `${REACT_APP_API_PREFIX}/${service}/quizCategories`;

export function getQuizCategories(filters) {
  const url = `${quizCategories}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getQuizCategoryById(id) {
  const url = `${quizCategories}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateQuizCategory(id, body) {
  const url = `${quizCategories}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteQuizCategory(id) {
  const url = `${quizCategories}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createQuizCategory(body) {
  const url = `${quizCategories}`;
  return {
    method: POST,
    url,
    body,
  };
}
